import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import am5index from '@amcharts/amcharts5/index';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
@Component({
  selector: 'stc-apps-rounded-bar-chart',
  standalone: false,
  templateUrl: './rounded-bar-chart.component.html',
  styleUrl: './rounded-bar-chart.component.scss',
})
export class RoundedBarChartComponent
  implements AfterViewInit, OnDestroy, OnChanges
{
  chartdiv_id = `${Math.random()}_chart_id`;
  root!: am5.Root;
  @Input() isNegativeValues = false;
  @Input() thresholdsData!: any[];
  @Input({ required: true }) colors: any[] = [];
  @Input({ required: true }) data: {
    gd: string;
    numberOfUnacceptableProjects: number | null;
    actualValue?: number;
    // threshold?: string;
    // color?: string;
  }[] = [];
  ngAfterViewInit(): void {
    this.roundedBarChart();
  }
  ngOnDestroy(): void {
    // 4. Clean up when component is removed
    if (this.root) {
      this.root.dispose();
    }
    am5.array.each(am5.registry.rootElements, (root) => {
      if (root && root.dom.id === this.chartdiv_id) {
        root.dispose();
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['data'] && !changes['data'].firstChange) ||
      (changes['thresholdsData'] && !changes['thresholdsData'].firstChange)
    ) {
      if (this.root) {
        this.roundedBarChart();
      }
    }
  }
  roundedBarChart() {
    if (this.root) {
      this.root.dispose();
    }
    // console.log(this.data);
    // console.log(this.thresholdsData);
    this.root = am5.Root.new(this.chartdiv_id);
    this.root.setThemes([am5themes_Animated.new(this.root)]);
    if (this.root._logo) {
      this.root._logo.dispose();
    }
    // إنشاء الـ Chart
    const chart = this.root.container.children.push(
      am5xy.XYChart.new(this.root, {
        panX: false,
        panY: false,
        wheelX: 'none',
        wheelY: 'none',
      })
    );
    const cursor = chart.set('cursor', am5xy.XYCursor.new(this.root, {}));
    cursor.lineY.set('visible', false);
    cursor.lineX.set('visible', false);
    cursor.setAll({
      snapToSeries: [],
    });
    const data = this.data;
    let xRenderer: any;
    if (!this.isNegativeValues) {
      xRenderer = am5xy.AxisRendererX.new(this.root, {
        minGridDistance: 30,
      });
    } else {
      xRenderer = am5xy.AxisRendererX.new(this.root, {
        minGridDistance: 60,
        visible: true,
        strokeOpacity: 1,
        strokeWidth: 2,
        stroke: am5.color('#E2E8F0'),
        // minorGridEnabled: true,
      });
    }
    xRenderer.labels.template.setAll({
      fontFamily: 'STCForwardFont',
      fill: am5.color(0x7a7a7b),
      fontSize: 13,
      paddingTop: 10,
      oversizedBehavior: !this.isNegativeValues ? 'truncate' : 'none',
      maxWidth: !this.isNegativeValues ? 50 : undefined, // Adjust this width as needed
      // rotation: -90,
      // centerY: am5.p50,
      // centerX: am5.p100,
      // paddingRight: 15,
    });
    chart.zoomOutButton.set('forceHidden', true);
    xRenderer.grid.template.setAll({
      forceHidden: true,
    });
    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(this.root, {
        categoryField: 'gd',
        renderer: xRenderer,
        // tooltip: am5.Tooltip.new(this.root, {}),
      })
    );

    xAxis.data.setAll(data);
    let allThresholdsValues: any[] = [];
    const allValues = data
      .map((d) => d.numberOfUnacceptableProjects)
      .filter((v) => typeof v === 'number') as number[];
    if (this.thresholdsData) {
      allThresholdsValues = this.thresholdsData
        .map((d) => d.value)
        .filter((v) => typeof v === 'number') as number[];
    }
    const allNumberValues = [...allValues, ...allThresholdsValues];
    const allNegative = allValues.length > 0 && allValues.every((v) => v <= 0);
    const allThresholdsNegative =
      allThresholdsValues.length > 0 &&
      allThresholdsValues.every((v) => v <= 0);
    const allPositive = allValues.length > 0 && allValues.every((v) => v > 0);
    // console.log('allNegative => ', allNegative);
    // console.log('allThresholdsNegative => ', allThresholdsNegative);
    // console.log(allNegative);
    // console.log(allThresholdsNegative);

    let allThresholdsValues2: any[] = [];
    const allValues2 = data
      .map((d) => d.actualValue)
      .filter((v) => typeof v === 'number') as number[];
    if (this.thresholdsData) {
      allThresholdsValues2 = this.thresholdsData
        .map((d) => d.label)
        .filter((v) => typeof v === 'number') as number[];
    }
    const allNumberValues2 = [...allValues2, ...allThresholdsValues2];
    const allNegative2 =
      allNumberValues2.length > 0 && allNumberValues2.every((v) => v <= 0);
    const allPositive2 =
      allNumberValues2.length > 0 && allNumberValues2.every((v) => v > 0);
    const yRenderer = am5xy.AxisRendererY.new(this.root, {
      // inversed: allNegative && allThresholdsNegative,
      strokeOpacity: 0,
      // minGridDistance: 120,
    });
    const dataValues = data.map((d) => d.numberOfUnacceptableProjects || 0);
    const dataMin = Math.min(...dataValues);
    const dataMax = Math.max(...dataValues);

    // 2. Get the range of threshold values
    const thresholdValues = this.thresholdsData?.map((t) => t.value) || [];
    const threshMin = thresholdValues.length
      ? Math.min(...thresholdValues)
      : dataMin;
    const threshMax = thresholdValues.length
      ? Math.max(...thresholdValues)
      : dataMax;

    const finalMin = Math.min(dataMin, threshMin, 0); // Include 0 to keep the base line visible
    let finalMax = Math.max(dataMax, threshMax);
    finalMax = finalMax + (finalMax - finalMin) * 0.15;
    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(this.root, {
        renderer: yRenderer,
        min: finalMin,
        max: finalMax,
        // strictMinMax: true,
        // max: Math.max(0, maxValue),
        // extraMin: 0,
        // extraMax: 2,
        // min: allNegative ? Math.min(...allValues) : undefined,
        // max: allNegative ? 0 : undefined,
      })
    );
    yRenderer.grid.template.setAll({
      // forceHidden: true,
      visible: false,
    });
    if (!this.isNegativeValues) {
      yRenderer.labels.template.setAll({
        forceHidden: true,
      });
    } else {
      yRenderer.labels.template.setAll({
        centerX: am5.p50,
        // visible: false,
        // forceHidden: true,
        opacity: 0,
      });
    }
    const series = chart.series.push(
      am5xy.ColumnSeries.new(this.root, {
        name: 'Visits',
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: 'numberOfUnacceptableProjects',
        categoryXField: 'gd',
        tooltip: am5.Tooltip.new(this.root, {
          labelText: this.isNegativeValues
            ? '{categoryX} : {actualValue}'
            : '{categoryX} : {valueY}',
        }),
      })
    );
    series.columns.template.setAll({
      cornerRadiusTL: !this.isNegativeValues ? 25 : 15,
      cornerRadiusTR: !this.isNegativeValues ? 25 : 15,
      cornerRadiusBL: !this.isNegativeValues ? 25 : 15,
      cornerRadiusBR: !this.isNegativeValues ? 25 : 15,
      width: !this.isNegativeValues ? am5.p50 : am5.percent(45),
      strokeOpacity: 0,
    });
    // إعداد شكل الأعمدة
    series.columns.template.setAll({
      fillOpacity: 1,
      strokeOpacity: 0,
      fill: am5.color('#5a5'),
    });
    xAxis.adapters.add('y', (y, target) => {
      return yAxis.valueToPosition(0);
    });
    // series.columns.template.adapters.add('visible', (visible, target: any) => {
    //   const v = target.dataItem?.get('valueY');
    //   if (v === 0) return false;
    //   return visible;
    // });

    series.columns.template.adapters.add('visible', (visible, target: any) => {
      // 1. Get the original data context to see the REAL value
      const context = target.dataItem?.dataContext as any;
      const realValue = context?.actualValue;

      // 2. Check if the real value is exactly 0
      if (realValue === 0) {
        // 3. Check if we have thresholds and if ALL of them are positive
        // We check 't.label' because that holds the original unshifted threshold value
        if (this.thresholdsData && this.thresholdsData.length > 0) {
          const allThresholdsPositive = this.thresholdsData.every(
            (t: any) => Number(t.label) > 0
          );

          // If thresholds are positive (e.g. 0.05, 0.2) and value is 0,
          // hide the bar so it doesn't look like a tiny "padding" bar.
          if (allThresholdsPositive) {
            return false;
          }
        }
      }

      // Keep your existing check for the calculated value (safety fallback)
      const v = target.dataItem?.get('valueY');
      if (v === 0) return false;

      return visible;
    });

    series.columns.template.adapters.add(
      'strokeOpacity',
      (opacity, target: any) => {
        const dataItem = target.dataItem;
        if (!dataItem) return opacity;

        const v = dataItem.get('valueY');
        if (v === 0) return 0;
        return 0;
      }
    );
    // series.columns.template.adapters.add(
    //   'interactive',
    //   (interactive, target: any) => {
    //     // const v = target.dataItem?.get('valueY');
    //     const v = target.dataItem?.dataContext.actualValue;
    //     if (v === 0) return false;
    //     return interactive;
    //   }
    // );
    // series.columns.template.adapters.add('height', (h, target: any) => {
    //   // const v = target.dataItem?.get('valueY');
    //   const v = target.dataItem?.dataContext.actualValue;
    //   // console.log(v);
    //   if (v === 0) return 0;
    //   return h;
    // });
    // series.columns.template.adapters.add('visible', (visible, target: any) => {
    //   const ctx = target.dataItem?.dataContext as any;
    //   const raw = ctx?.actualValue;

    //   if (typeof raw === 'number' && Math.abs(raw) < 1e-9) return false;
    //   return visible;
    // });
    // series.columns.template.adapters.add('fillOpacity', (op, target: any) => {
    //   // const v = target.dataItem?.get('valueY');
    //   const v = target.dataItem?.dataContext.actualValue;
    //   if (v === 0) return 0;
    //   return 1;
    // });
    // مهم: امنع العمود المخفي من استقبال hover (عشان مايبقاش فيه hit area غريب)
    // series.columns.template.adapters.add('interactive', (interactive, target: any) => {
    //   const dataItem = target.dataItem;
    //   const v = dataItem?.get('valueY');
    //   if (v === 0) return false;
    //   return true;
    // });
    // Optional: Ensure labels don't overlap the bars
    xRenderer.labels.template.setAll({
      centerY: am5.p0, // Anchors the top of the label to the 0 line
      paddingTop: 10,
    });
    series.bullets.push((root, series, dataItem) => {
      const value = dataItem.get('valueY');
      if (value === null || value === undefined || Number.isNaN(value)) {
        return undefined;
      }
      const allPositive = allValues.length > 0 && allValues.every((v) => v > 0);
      const allNegative = allValues.length > 0 && allValues.every((v) => v < 0);
      const label = am5.Label.new(root, {
        text: !this.isNegativeValues
          ? "{valueYWorking.formatNumber('#.')}"
          : '{actualValue}',
        fill: root.interfaceColors.get('alternativeText'),
        centerX: am5.p50,
        dy: -10,
        // centerY: am5.p0,
        populateText: true,
        fontFamily: 'STCForwardFont',
        fontSize: 13,
      });
      const rangeDataItem = yAxis.makeDataItem({
        value: 0,
      });
      chart.plotContainer.setAll({
        paddingTop: 0,
        // mask: false, // مهم جداً: يمنع قص أي حاجة طالعة برا
      });
      // chart.setAll({
      //   height: 100,
      // });
      // if (!allPositive2 && !allNegative2) {
      //   const range = yAxis.createAxisRange(rangeDataItem);
      //   range.get('grid')?.setAll({
      //     stroke: am5.color(0xccd6dd),
      //     strokeOpacity: 1,
      //     strokeWidth: 2,
      //     visible: true,
      //   });
      //   xRenderer.setAll({
      //     strokeOpacity: 0, // Hide the default axis line
      //   });
      // }
      label.adapters.add('visible', (visible: any, target: any) => {
        const v = (dataItem.get('valueYWorking') ?? dataItem.get('valueY')) as
          | number
          | null;

        if (v == null || Number.isNaN(v)) return false;

        // ارتفاع منطقة الرسم (بالبكسل)
        const plotH = chart.plotContainer.height();

        // لو لسه layout ماحسبش الارتفاع
        if (!plotH || plotH <= 0) return true;

        const hPx =
          Math.abs(yAxis.valueToPosition(v) - yAxis.valueToPosition(0)) * plotH;

        return hPx > 30;
      });
      return am5.Bullet.new(root, {
        locationY: 0.5,
        sprite: label,
      });
    });
    if (this.thresholdsData) {
      series.columns.template.adapters.add('fill', (fill, target: any) => {
        const dataItem = target.dataItem;
        if (dataItem) {
          const value = dataItem.get('valueY') as number;

          // Sort thresholds to ensure we compare against the correct boundaries
          const sortedThresholds = [...this.thresholdsData].sort(
            (a, b) => a.value - b.value
          );

          const lowest = sortedThresholds[0].value;
          const highest = sortedThresholds[sortedThresholds.length - 1].value;
          // console.log('lowest => ', lowest); // -0.25
          // console.log('highest => ', highest); // -0.15
          // console.log('value => ', value); // -0.1
          let allThresholdsValues2: any[] = [];
          const allValues2 = data
            .map((d) => d.actualValue)
            .filter((v) => typeof v === 'number') as number[];
          if (this.thresholdsData) {
            allThresholdsValues2 = this.thresholdsData
              .map((d) => d.label)
              .filter((v) => typeof v === 'number') as number[];
          }
          const allNegative2 =
            allValues2.length > 0 && allValues2.every((v) => v <= 0);
          const allThresholdsNegative2 =
            allThresholdsValues2.length > 0 &&
            allThresholdsValues2.every((v) => v < 0);
          // 1. Red: value is less than or equal to the lowest threshold

          if (value <= lowest) {
            // console.log('value <= lowest');

            return am5.color(this.colors[2]); // Red
          }
          // 2. Green: value is greater than or equal to the highest threshold
          else if (value >= highest) {
            // console.log('value >= highest');
            return am5.color(this.colors[0]); // Green
          }
          // 3. Yellow: value is anywhere in between
          else if (value > lowest && value < highest) {
            // console.log('value is between lowest and highest');
            return am5.color(this.colors[1]); // Yellow
          }
        }
        return fill;
      });
    } else {
      series.columns.template.adapters.add('fill', (fill, target: any) => {
        // return chart.get('colors')?.getIndex(series.columns.indexOf(target));
        return am5.color(this.colors[2]); // Default color
      });
    }
    series.columns.template.adapters.add('stroke', function (stroke, target) {
      return chart.get('colors')?.getIndex(series.columns.indexOf(target));
    });

    const createStaticThreshold = (
      actualValue: number, // Use the real number (0.8, 0.9, etc)
      color: string,
      labelText: string,
      dyOffset = 0
    ) => {
      // const staticValue = (yAxis.get('max') || maxY) * actualValue;
      // console.log(staticValue);
      const rangeDataItem = yAxis.makeDataItem({
        value: actualValue,
      });

      const range = yAxis.createAxisRange(rangeDataItem);
      range.get('grid')?.setAll({
        stroke: am5.color(color),
        strokeOpacity: 1,
        strokeWidth: 2,
        strokeDasharray: [3, 3],
        visible: true,
        location: 0.5,
        dy: dyOffset,
      });

      range.get('label')?.setAll({
        text: labelText,
        fill: am5.color(color),
        visible: true,
        centerY: am5.p50,
        centerX: am5.p100, // Aligns text to the left of the Y-axis
        dx: 5, // Space between text and the axis line
        fontFamily: 'STCForwardFont',
        dy: dyOffset,
        fontSize: 11,
        location: 0.5,
        isMeasured: false, // Prevents the label from pushing the axis
        opacity: 1,
      });
    };
    if (this.thresholdsData) {
      // console.log(this.thresholdsData);
      const sortedThresholds = [...this.thresholdsData].sort(
        (a, b) => a.value - b.value
      );
      const redT = sortedThresholds[0];
      const greenT = sortedThresholds[sortedThresholds.length - 1];

      const isYellow = (t: any) =>
        String(t.color).toLowerCase() === this.colors[1];
      const almostEqual = (a: number, b: number, eps = 1e-9) =>
        Math.abs(a - b) < eps;
      const totalRange = finalMax - finalMin;
      const minDistance = totalRange * 0.09;
      // 3. Loop and apply Stacking
      let currentShift = 0; // Tracks how much we need to move up

      sortedThresholds.forEach((t, index) => {
        if (
          isYellow(t) &&
          (almostEqual(Number(t.label), Number(redT.label)) ||
            almostEqual(Number(t.label), Number(greenT.label)))
        ) {
          return; // skip رسم الخط واللابل
        }
        // If it's not the first item, compare with the previous one
        if (index > 0) {
          const prev = sortedThresholds[index - 1];
          // console.log('prev => ', prev);
          // console.log('prev.value => ', prev.value);
          // console.log('t.value => ', t.value);
          // console.log('minDistance => ', minDistance);

          if (t.value - prev.value < minDistance) currentShift -= 20;
          else currentShift = 0;
        }

        createStaticThreshold(t.value, t.color, `${t.label}%`, currentShift);

        // 4. Create the threshold with the calculated offset
        // createStaticThreshold(
        //   t.value,
        //   t.color,
        //   `${t.label}%`,
        //   currentShift // Pass the calculated offset
        // );
      });
    }

    const getDynamicColor = (value: number) => {
      if (!this.thresholdsData || this.thresholdsData.length === 0) {
        return am5.color(this.colors[2]);
      }

      const absValue = value;
      const sortedThresholds = [...this.thresholdsData].sort(
        (a, b) => a.value - b.value
      );

      // Green (smallest threshold)
      if (absValue <= sortedThresholds[0].value) {
        return am5.color(sortedThresholds[0].color);
      }
      // Yellow (between green and highest)
      if (sortedThresholds[1] && absValue <= sortedThresholds[1].value) {
        return am5.color(sortedThresholds[1].color);
      }
      // Red (highest)
      return am5.color(sortedThresholds[sortedThresholds.length - 1].color);
    };

    // 2. Adapter for Fill (Background)
    // series.columns.template.adapters.add('fill', (fill, target: any) => {
    //   // FIX: Cast dataItem to 'any' or 'am5xy.ColumnSeriesDataItem' to access 'valueY'
    //   const dataItem = target.dataItem;
    //   const value = dataItem?.get('valueY');

    //   if (typeof value === 'number') {
    //     return getDynamicColor(value);
    //   }
    //   return fill;
    // });

    // 3. Adapter for Stroke (Border)
    series.columns.template.adapters.add('stroke', (stroke, target: any) => {
      // FIX: Cast here as well
      const dataItem = target.dataItem;
      const value = dataItem?.get('valueY');

      if (typeof value === 'number') {
        return getDynamicColor(value);
      }
      return stroke;
    });

    series.data.setAll(data);

    // Animation
    series.appear(1000);
    chart.appear(1000, 100);
  }
}
